export default __webpack_public_path__ + "static/media/astronaut_home.e3939ab6.png";